(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function parseStatValue(raw) {
    if (!raw || typeof raw !== 'string') return { end: 0, suffix: '', prefix: '' };
    var trimmed = raw.trim();
    var prefix = '';
    var suffix = '';
    var numPart = trimmed;
    var leadMatch = trimmed.match(/^([^\d]*)([\d,.\s]+)(.*)$/);
    if (leadMatch) {
      prefix = leadMatch[1] || '';
      numPart = leadMatch[2] || '0';
      suffix = leadMatch[3] || '';
    }
    var end = parseFloat(numPart.replace(/,/g, ''), 10);
    if (Number.isNaN(end)) end = 0;
    return { end: end, suffix: suffix, prefix: prefix };
  }

  function formatStat(n, parsed) {
    var rounded = Math.round(n);
    var withCommas = rounded.toLocaleString('en-IN');
    return parsed.prefix + withCommas + parsed.suffix;
  }

  function initFadeUp() {
    document.querySelectorAll('.shopify-section[class*="lc-about-"] > section').forEach(function (el) {
      if (!el.hasAttribute('data-lc-about-fade')) {
        el.setAttribute('data-lc-about-fade', '');
      }
    });

    if (reduced) {
      document.querySelectorAll('[data-lc-about-fade]').forEach(function (el) {
        el.classList.add('lc-about--visible');
      });
      return;
    }

    var nodes = document.querySelectorAll('[data-lc-about-fade]');
    if (!nodes.length || !('IntersectionObserver' in window)) {
      nodes.forEach(function (el) {
        el.classList.add('lc-about--visible');
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('lc-about--visible');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    nodes.forEach(function (el) {
      io.observe(el);
    });
  }

  function initStats() {
    var items = document.querySelectorAll('[data-lc-stat-value]');
    if (!items.length) return;

    function animateEl(el) {
      if (el.dataset.lcStatDone === '1') return;
      el.dataset.lcStatDone = '1';
      var raw = el.getAttribute('data-stat-raw') || '';
      var parsed = parseStatValue(raw);
      if (parsed.end <= 0 || reduced) {
        el.textContent = raw;
        return;
      }
      var start = 0;
      var duration = 1400;
      var t0 = performance.now();
      function tick(now) {
        var p = Math.min(1, (now - t0) / duration);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = formatStat(start + (parsed.end - start) * eased, parsed);
        if (p < 1) requestAnimationFrame(tick);
        else el.textContent = raw;
      }
      requestAnimationFrame(tick);
    }

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) {
        el.textContent = el.getAttribute('data-stat-raw') || '';
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animateEl(entry.target);
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.35 }
    );
    items.forEach(function (el) {
      if (!reduced) el.textContent = '0';
      io.observe(el);
    });
  }

  function initTimelineLine() {
    var wrap = document.querySelector('[data-lc-timeline-track]');
    if (!wrap || reduced) {
      if (wrap) wrap.style.setProperty('--lc-timeline-progress', '100%');
      return;
    }
    var line = wrap.querySelector('[data-lc-timeline-line]');
    if (!line) return;

    function update() {
      var rect = wrap.getBoundingClientRect();
      var vh = window.innerHeight || 800;
      var start = vh * 0.85;
      var end = vh * 0.25;
      var total = rect.height;
      if (total <= 0) return;
      var top = rect.top;
      var traveled = start - top;
      var range = total + (start - end);
      var pct = Math.max(0, Math.min(100, (traveled / range) * 100));
      wrap.style.setProperty('--lc-timeline-progress', pct + '%');
    }

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
  }

  function init() {
    initFadeUp();
    initStats();
    initTimelineLine();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
